import * as selector from "./selector";
import { Headers } from "./header";
import { can, canAny } from "./permissions";

// API URLs from environment variables (Create React App uses process.env.REACT_APP_*)
const JSON_URL = process.env.REACT_APP_JSON_URL;
const auth = process.env.REACT_APP_AUTH_API;
const dictionary = process.env.REACT_APP_DICTIONARY_API;
const kaya = process.env.REACT_APP_KAYA_API;
const boundary = process.env.REACT_APP_BOUNDARY_API;
const building = process.env.REACT_APP_BUILDING_API;
const image = process.env.REACT_APP_IMAGE_API;

const options = [
  { value: "5", label: "5" },
  { value: "10", label: "10" },
  { value: "20", label: "20" },
  { value: "50", label: "50" },
  { value: "100", label: "100" },
];

export {
  JSON_URL,
  auth,
  dictionary,
  kaya,
  boundary,
  building,
  image,
  options,
  selector,
  Headers,
  can,
  canAny,
};
